import { Injectable } from '@angular/core';
import * as SecureLS from 'secure-ls';

@Injectable()
export class SLSService {
  static setKeyValue(key: string, value): void {
    const secureLS = new SecureLS({ encodingType: 'aes', encryptionSecret: 'qRI37uAolO7jZ4mjoeKyeaJJ5', isCompression: true });
    secureLS.set(key, value);
  }

  static getValueByKey(key: string) {
    const secureLS = new SecureLS({ encodingType: 'aes', encryptionSecret: 'qRI37uAolO7jZ4mjoeKyeaJJ5', isCompression: true });
    return secureLS.get(key) !== '' ? secureLS.get(key) : null;
  }

  static removeKey(key: string) {
    const secureLS = new SecureLS();
    return secureLS.remove(key);
  }

  static removeAll() {
    const secureLS = new SecureLS();
    return secureLS.removeAll();
  }
}
